var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97897 9.646C4.86764 9.646 4.75997 9.625 4.65597 9.583C4.55197 9.54167 4.4513 9.47234 4.35397 9.375L0.832969 5.854C0.666303 5.68734 0.586636 5.47567 0.593969 5.219C0.600636 4.96167 0.687303 4.74967 0.853969 4.583C1.02064 4.41634 1.22897 4.333 1.47897 4.333C1.72897 4.333 1.9373 4.41634 2.10397 4.583L5.02097 7.5L11.917 0.604004C12.0836 0.437337 12.2883 0.354004 12.531 0.354004C12.7743 0.354004 12.9793 0.437337 13.146 0.604004C13.3126 0.770671 13.396 0.97567 13.396 1.219C13.396 1.46167 13.3126 1.66634 13.146 1.833L5.60397 9.375C5.50664 9.47234 5.40597 9.54167 5.30197 9.583C5.19797 9.625 5.0903 9.646 4.97897 9.646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2e32c3b5c995d082fccdaf5f2751a4ca.svg";
export { ForwardRef as ReactComponent };